exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".S2y8ZmAKwlHAv142-kvQ0{height:36px}", ""]);

// exports
exports.locals = {
	"favoritesPickerContainer": "S2y8ZmAKwlHAv142-kvQ0"
};